import styled from 'styled-components';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const ChartContainer = styled.div`
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.16);
  height: 300px;
`;

const Title = styled.h4`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1d2f35;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme: t }) => t.colors.border};
  margin: 0.4rem 0 0.8rem 0;
`;

type Props = {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
};

export const BarChartCard = ({ title, data }: Props) => {
  return (
    <ChartContainer>
      <Title>{title}</Title>
      <Divider />
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={data}>
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="earning" fill="#2ecc71" />
          <Bar dataKey="out" fill="#e74c3c" />
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
